import axios from '@/libs/api.request'

export const getJobfaironlinelist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/jobfaironline/jobfaironline/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationJobfaironline = (data, meth) => {
  return axios.request({
    url: '/v1/jobfaironline/jobfaironline/',
    method: meth,
    data
  })
}
